<div class="refstrip-wrapper" [class.hidden]="!isVisible">
  <ng-content></ng-content>
  <cdk-virtual-scroll-viewport id="referenceStrip" orientation="horizontal">
    <div class="stripThumbnail" *cdkVirtualFor="let item of items; let stripItemIndex = index"
      (click)="changeIndex.emit(item.index)" (contextmenu)="onThumbnailContextMenu($event, item)"
      [class.active]="selectedIndex === item.index" [class.viewed]="viewedItems.includes(item.id)"
      [class.processing]="item.state === State.PROCESSING" [class.hidden]="item.hidden"
      [matTooltip]="'alert.image_still_processing' | translate"
      [matTooltipDisabled]="!(item.state === State.PROCESSING)">
      <div class="stripTitleBar">
        <div class="icons-bar horizontal">
          <span class="badge-index">
            <i *ngIf="bookmarkedAsset === item.id" id="bookmark-icon" class="ri-bookmark-fill"></i>
            {{ item.index + 1 }}
          </span>
          <i *ngIf="item.fav" class="ri-star-line"> </i>
          <i *ngIf="favAssets.includes(item.id)" class="ri-heart-3-line"> </i>
          <i *ngIf="analyzedAssets.includes(item.id)" class="ri-shape-line"
            [class.reviewed]="reviewedAssets.includes(item.id)">
          </i>
        </div>
      </div>
      <ng-container *ngIf="!(item.state === State.PROCESSING); else loading">
        <img [src]="item.thumbnail | preprocess | async" alt="asset thumbnail {{ stripItemIndex + 1 }}" #thumbnail />
      </ng-container>
      <ng-template #loading>
        <img src="assets/media/image_placeholder.svg" alt="asset thumbnail {{ stripItemIndex + 1 }}" />
      </ng-template>
    </div>
  </cdk-virtual-scroll-viewport>
  <button class="refstrip-toggle" (click)="toggleVisibility()"
    [matTooltip]="(isVisible ? 'navigation.hide_reference_strip' : 'navigation.show_reference_strip') | translate">
    <i [class]="isVisible ? 'ri-arrow-down-s-line' : 'ri-arrow-up-s-line'"></i>
  </button>
</div>
